import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getHelixUIMode } from 'utils/helix';
import Heading from 'components/Heading';
import Card from 'components/Card';
import PercentageDisc from 'components/PercentageDisc';
import Flag from 'components/Flag';
import FormattedText from 'components/FormattedText';
import UserGeneratedText from 'components/UserGeneratedText';
import Stack from 'components/Stack';
import TextLink from 'components/TextLink';
import Icon from 'components/Icon';
import Text from 'components/Text';
import IconDisc from 'components/IconDisc';
import QuoteSection from './QuoteSection';
import ButtonRow from './ButtonRow';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function demoteMarkdownHeadings(html) {
  // markdown-it never adds attributes to plain ATX headings so these are simple
  return html.replace(/<(\/?)h4>/g, '<$1h5>');
}
function SkillScoreFlagCard(_ref) {
  var _skill$skillUsage, _skill$skillUsage2;
  var _ref$canShowButtonRow = _ref.canShowButtonRow,
    canShowButtonRow = _ref$canShowButtonRow === void 0 ? true : _ref$canShowButtonRow,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 0 : _ref$decimalPlaces,
    isCurrentUser = _ref.isCurrentUser,
    userId = _ref.userId,
    skill = _ref.skill,
    getLink = _ref.getLink;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _getHelixUIMode = getHelixUIMode(),
    showScores = _getHelixUIMode.showScores,
    scoreOutOf = _getHelixUIMode.scoreOutOf;
  var wasSkillUsed = skill === null || skill === void 0 ? void 0 : skill.id; // Has an analysis record for this skill

  var positiveSkillUsage = (skill === null || skill === void 0 || (_skill$skillUsage = skill.skillUsage) === null || _skill$skillUsage === void 0 ? void 0 : _skill$skillUsage.positive) || [];
  var negativeSkillUsage = (skill === null || skill === void 0 || (_skill$skillUsage2 = skill.skillUsage) === null || _skill$skillUsage2 === void 0 ? void 0 : _skill$skillUsage2.negative) || [];
  var showButtonRow = canShowButtonRow && isCurrentUser;
  return /*#__PURE__*/_jsx(Flag, {
    token: showScores ? /*#__PURE__*/_jsx(PercentageDisc, {
      shady: true,
      percentage: skill.score || undefined,
      outOf: scoreOutOf,
      decimalPlaces: decimalPlaces
    }) : /*#__PURE__*/_jsx(IconDisc, {
      size: "big",
      shady: true,
      name: "asset-fluidbook"
    }),
    align: "top",
    children: /*#__PURE__*/_jsxs(Card, {
      px: "m",
      py: "s",
      dimmed: !wasSkillUsed,
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h3",
        mb: "s",
        children: /*#__PURE__*/_jsxs(TextLink, {
          stealthy: true,
          as: Link,
          to: getLink({
            skillId: skill.skillId
          }),
          children: [skill.name, /*#__PURE__*/_jsx(Icon, {
            name: "arrow-right",
            size: "unscaled",
            ml: "xs"
          })]
        })
      }), wasSkillUsed ? /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [(skill === null || skill === void 0 ? void 0 : skill.summary) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h4",
            mb: "xs",
            children: t('property_summary')
          }), skill !== null && skill !== void 0 && skill.summaryHtml ? /*#__PURE__*/_jsx(FormattedText, {
            dangerouslySetInnerHTML: {
              __html: demoteMarkdownHeadings(skill.summaryHtml)
            }
          }) : /*#__PURE__*/_jsx(UserGeneratedText, {
            text: skill.summary
          })]
        }), (skill === null || skill === void 0 ? void 0 : skill.suggestion) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h4",
            mb: "xs",
            children: t('property_suggestions')
          }), /*#__PURE__*/_jsx(UserGeneratedText, {
            text: skill.suggestion
          })]
        }), (positiveSkillUsage.length > 0 || negativeSkillUsage.length > 0) && /*#__PURE__*/_jsx(QuoteSection, {
          headingLevel: "h4",
          positiveSkillUsage: positiveSkillUsage,
          negativeSkillUsage: negativeSkillUsage
        }), showButtonRow && /*#__PURE__*/_jsx(ButtonRow, {
          isCurrentUser: isCurrentUser,
          userId: userId,
          skillId: skill.skillId,
          skillName: skill.name,
          summary: skill.summary,
          suggestion: skill.suggestion
        })]
      }) : /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Text, {
          dimmed: true,
          children: t('skills_empty_state_skill_not_recorded_during_meeting')
        }), showButtonRow && /*#__PURE__*/_jsx(ButtonRow, {
          isCurrentUser: isCurrentUser,
          userId: userId,
          skillId: skill.skillId,
          skillName: skill.name
        })]
      })]
    })
  });
}
export default SkillScoreFlagCard;